import axios from 'axios';
import { baseUrl, token } from '../../services/Apis';

export const permisosApi = `${baseUrl}/usuent-perfil-permisos`;

export const allPermisosService = async (params) => {
  const res = await axios.get(permisosApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const savePermisosService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${permisosApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(permisosApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const onePermisosService = async (id) => {
  const res = await axios.get(`${permisosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deletePermisosService = async (id) => {
  const res = await axios.delete(`${permisosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
